import { useSyncExternalStore } from "react";

/**
 * How long a server round trip may run before a portal explains the wait.
 * Shared by the global request banner and every LoadingScreen so the two can
 * never disagree about when a request has become slow enough to talk about.
 */
export const LONG_REQUEST_FEEDBACK_DELAY_MS = 1000;

let visibleLoadingScreenCount = 0;
const listeners = new Set<() => void>();

function emitChange() {
  for (const listener of listeners) listener();
}

/**
 * Called by a LoadingScreen once it becomes visible, so the global banner can
 * stay out of the way rather than stacking a second message on top of a screen
 * that already explains the wait.
 */
export function registerVisibleLoadingScreen(): () => void {
  visibleLoadingScreenCount += 1;
  emitChange();

  let released = false;
  return () => {
    if (released) return;
    released = true;
    visibleLoadingScreenCount = Math.max(0, visibleLoadingScreenCount - 1);
    emitChange();
  };
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot() {
  return visibleLoadingScreenCount;
}

export function useVisibleLoadingScreenCount(): number {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}

export function resetLoadingFeedbackForTests() {
  visibleLoadingScreenCount = 0;
  emitChange();
}
